// @flow
import type { ContextRouter } from '../../core/types'
import type { Charity } from '../charity/types'
import { withProps, compose } from 'recompose'
import withTranslations from '../../core/withTranslations'
import withRouter from 'react-router-dom/withRouter'

type WizardDataProps = {
  currentStep: number,
  setWizardStep: number => void,
  charity: Charity,
  removeCharity: () => void
}
type ProvidedProps = WizardDataProps & ContextRouter

const handlers = withProps((props: ProvidedProps) => {
  const {
    currentStep = 1,
    setWizardStep,
    charity,
    history,
    removeCharity
  } = props
  return {
    onBack(e) {
      if (currentStep === 1) {
        if (charity && !charity.published) removeCharity()
        history.replace('/explore')
      } else {
        return setWizardStep(currentStep - 1)
      }
    },
    onNext(e) {
      if (currentStep < 4) {
        return setWizardStep(currentStep + 1)
      } else {
        history.push('/mycharity')
      }
    }
  }
})

const translations = withTranslations(({ currentStep }: ProvidedProps) => {
  const cancelText =
    currentStep && currentStep > 1 ? 'common:back' : 'common:cancel'
  const saveText =
    !currentStep || currentStep < 3 ? 'common:next' : 'common:finish'
  return { cancelText, saveText }
})

export default compose(withRouter, handlers, translations)



// WEBPACK FOOTER //
// ./src/services/register-charity/withBackAndNext.js